import type { ReactNode } from 'react';

import { Button } from '@shared/components';

interface Props {
  children?: ReactNode;
  okText?: string;
  onOk?: () => void;
}

const ConfirmModal = ({ children, okText, onOk }: Props) => (
  <div>
    {children}
    <Button className="h-12 w-full rounded-lg text-center font-semibold" onClick={onOk} variant="primary">
      <span className="text-base text-white">{okText}</span>
    </Button>
  </div>
);

export default ConfirmModal;
